import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ReportTotalResidual {
  @JsonProperty()
  counterParty: string;
  @JsonProperty()
  deskId: string;
  @JsonProperty()
  origin: ReportTotalResidual.Origin;
  @JsonProperty()
  businessDate: DateTime;
  @JsonProperty()
  totalResidual: number;
}

export module ReportTotalResidual {
  export enum Origin {
    ORDER = "ORDER",
    TRADE = "TRADE",
    FORCE = "FORCE",
  }
}

